<!-- 下拉选择器组件分装 -->
<template>
  <div>
    <el-dialog :title="showTitle" :visible.sync="dialogShow" width="600px" append-to-body :before-close="()=>{handleCallBack()}"
			:close-on-click-modal="false">
    <el-form label-position="right" ref="addForm" label-width="70px" class="postForm">
				<el-form-item label="导入文件:" label-width="150px">
					<el-upload ref="upload" action="" :before-upload="beforeUploadXls" accept="excel/xls,excel/xlsx">
						<el-button size="small" type="primary" :loading="uploading">点击上传</el-button>	
  						<div slot="tip" class="el-upload__tip">
							<div style="color:blue;line-height: 25px;">1、打*星号为必填项,只允许上传xls,xlsx格式,</div>
							<div style="color:blue;line-height: 25px;">2、自动过滤重复记录</div>
							<div style="color:blue;line-height: 25px;">3、自动跳过错误记录</div>
						</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="" label-width="150px">
					<span><a :href="'/static/'+templateName+'.xlsx'" target="_blank" style="color:green">下载模板</a></span>
				</el-form-item>
			</el-form>
      </el-dialog>
  </div>
</template>
  
<script>
export default {
  name: "import-xls",
  props: ["templateName","importUrl","showTitle","dialogShow"],
  data() {
    return {
			uploading:false,
    }
  },
  methods: {
    handleCallBack() {
      this.$emit("callBack", '');
    },
    beforeUploadXls(file) {
			this.uploading=true;
			let formData = new FormData();
			formData.append('file', file);//传文件
			this.$axios.post(this.importUrl, formData).then(res => {
				if (res.data.status == 0) {
					this.$message(res.data.data);
				}
				else{
					this.$message(res.data.msg);
				}
        this.uploading=false
				this.handleCallBack()
			})
			return false;
		},
  },
}
</script>
  
<style scoped lang="scss">

</style>
  
  